import React, {useState} from 'react';
import { withStyles } from "@mui/styles";
import {Dialog, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import {Styles} from "../../../../config/design/styles";
import Button from "@mui/material/Button";
import {showExactDate} from "../../../../config/values";
import {ChevronRight,CircleCheck,Circle,CircleX} from "lucide-react";
import Grid from "@mui/material/Grid2";
import LoadingButton from "../../../components/elements/LoadingButton";
import axios from "axios";
import {defaultVariables} from "../../../../config";

function ChangeOrderStatusFromPendingButton({order,role,classes,reload }) {
    const { t } = useTranslation();
    const [open,setOpen] = useState(false);
    const [orderStatus,setOrderStatus] = useState("making");
    const [submitLoading, setSubmitLoading] = useState(false);

    const handleRequest = async () => {
        setSubmitLoading(true);
        const data = new FormData();
        data.append('order_id', order.id);
        data.append('order_status', orderStatus);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/orders/change-status-from-pending`, data, config);
            setSubmitLoading(false);
            reload();
            setOpen(false);
        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);

        }
    }
    return (
        <>
            <Button
                className={classes.buttonAlert}
                onClick={() => setOpen(true)}
                endIcon={<ChevronRight/>}
                color="primary"
                variant="contained"
            >
                {t('confirmRejectOrder')}
            </Button>
            <Dialog  open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle className="dialog-title">
                    {t('confirmRejectOrder')}
                    <IconButton
                        onClick={() => setOpen(false)}
                        style={{position:"absolute",right:15,top:15}}
                        size="small"
                    >
                        <Close className="lucide-icon"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item size={12}>
                            <Typography className="text-center bg-gray-box">{t('preparationTimeIs')} <strong>{showExactDate(order.order_time,order.shop.preparation_time)}</strong></Typography>
                        </Grid>
                        <Grid item size={12} className="flex-direction flex-justify-center flex-column-md">
                            <Button
                                onClick={() => setOrderStatus('making')}
                                startIcon={orderStatus === "making" ? <CircleCheck/> : <Circle/>}
                                variant={"outlined"}
                                size="large"
                                color={orderStatus === "making" ? 'secondary' : "default"}
                            >
                                {t('confirmOrder')}
                            </Button>
                            <Button
                                onClick={() => setOrderStatus('canceled')}
                                startIcon={orderStatus === "canceled" ? <CircleX/> : <Circle/>}
                                variant={"outlined"}
                                size="large"
                                color={orderStatus === "canceled" ? 'primary' : "default"}
                            >
                                {t('rejectOrder')}
                            </Button>
                        </Grid>

                            {
                                orderStatus === "making" &&
                                <>
                                    <Grid item size={12}>
                                        <Typography color="secondary">{t('confirmOrderDesc')}</Typography>
                                    </Grid>
                                </>
                            }
                        {
                            orderStatus === "canceled" &&
                            <>
                                <Grid item size={12}>
                                    <Typography color="primary" className="mb-10">{t('rejectOrderDesc')}</Typography>
                                    <Typography color="primary"><strong>{t('rejectOrderDesc2')}</strong></Typography>
                                </Grid>
                            </>
                        }

                        <Grid item size={12}>
                            <LoadingButton
                                className="confirm-btn"
                                variant="contained"
                                color={orderStatus === "canceled" ? 'primary' : "secondary"}
                                onClick={() => handleRequest()}
                                loading={submitLoading}
                            >
                                {orderStatus === "making" ? t("confirm") : t("reject")}
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(ChangeOrderStatusFromPendingButton));
